export default __webpack_public_path__ + "static/media/noti.8a15a07c.mp3";